import * as zod from 'zod';

import { movementActivity } from '../Variables';

export const RotaryWeldVariables = zod.object({
  completedWeldCount: zod.number().int().nonnegative(),
  currentActivity: zod.enum([
    'none',
    'approaching',
    'checkingAlignment',
    'settingWeldParameters',
    'startArc',
    'startingPositioner',
    'rotating',
    'stoppingPositioner',
    'craterFilling',
    'stopArc',
  ]),
  /**
   * Only the approach moves the arm, so `WeldVariables`' `weldMovementActivity`
   * has no analog here — nothing moves while the arc is live except the part,
   * which is the positioner's business.
   */
  approachMovementActivity: movementActivity,
});

export type RotaryWeldVariables = zod.infer<typeof RotaryWeldVariables>;
